import RouteTemplate from 'ember-route-template';

export default RouteTemplate(
  <template>
    <section class="pd-best-for">
      <div class="pd-best-for__hero">
        <a class="pd-best-for__back" href="/providers/{{@controller.model.slug}}">← {{@controller.model.name}}</a>
        <h1 class="pd-best-for__title">{{@controller.model.title}}</h1>
        <p class="pd-best-for__subtitle">
          Top 10 {{@controller.model.name}} alternatives ranked by rating, performance, and value.
        </p>
      </div>
    
      <div class="pd-best-for__ranked-list">
        {{#each @controller.model.providers as |p|}}
          <a class="pd-best-for__rank-item {{p.rankClass}}" href={{p.url}}>
            <div class="pd-best-for__rank-num">{{p.rank}}</div>
            <div class="pd-best-for__logo">
              {{#if p.logo_url}}
                <img src={{p.logo_url}} alt={{p.name}} class="pd-best-for__logo-img" loading="lazy" />
              {{else}}
                <span class="pd-card__logo-placeholder">{{p.logoInitial}}</span>
              {{/if}}
            </div>
            <div class="pd-best-for__details">
              <h3 class="pd-best-for__provider-name">{{p.name}}</h3>
              <div class="pd-best-for__provider-meta">
                <span>★ {{p.ratingDisplay}}</span>
                <span>{{p.costDisplay}}</span>
                <span>{{p.proxy_type}}</span>
              </div>
            </div>
            <span class="pd-best-for__cta">View →</span>
          </a>
        {{else}}
          <div class="pd-empty">
            <div class="pd-empty__icon">🔍</div>
            <div class="pd-empty__title">No alternatives found</div>
            <div class="pd-empty__body">No providers with a similar profile were found for comparison.</div>
          </div>
        {{/each}}
      </div>
    </section>

  </template>
);
